<template>
  <div>
    <CoachingCategories
      style="margin-bottom: 18px;"
      :category-loading="processLoading"
      :categories="formattedCategory"
    />
    <CategoryEditor
      :categories="categories"
    />
  </div>
</template>

<script>
import api from '@/api';
import CoachingCategories from './widget/CoachingCategories.vue';
import CategoryEditor from './widget/CategoryEditor.vue';

export default {
  name: 'Category',

  components: {
    CoachingCategories,
    CategoryEditor,
  },

  data: () => ({
    processLoading: false,
    categories: {
      tier_1: { options: [] },
      tier_2: { options: [] },
      tier_3: { options: [] },
      tier_4: { options: [] },
      tier_5: { options: [] },
      tier_6: { options: [] },
      tier_7: { options: [] },
      tier_8: { options: [] },
    },
  }),

  computed: {
    formattedCategory() {
      const list = [];
      if (this.categories) {
        Object.keys(this.categories).forEach((key) => {
          list.push({
            category: { key, title: this.categories[key].title },
            options: this.categories[key].options,
          });
        });
      }
      return list;
    },
  },

  mounted() {
    this.getPricing();
  },

  methods: {
    async getPricing() {
      try {
        this.processLoading = true;
        const priceFromServer = await api.getCategoryPricing();
        const response = priceFromServer.data;

        Object.keys(response).forEach((tier) => {
          const raw = [];
          Object.keys(response[tier]).forEach((session) => {
            if (session.includes('session') || session.includes('no_growth')) {
              if (response[tier][session] === 'pro_bono') {
                response[tier][session] = response[tier][session].replace('_', ' ');
              }
              if (!raw.length) {
                raw.push({ span: 0, item: response[tier][session] });
              } else if ((raw[raw.length - 1].item) === response[tier][session]) {
                raw[raw.length - 1].span = raw[raw.length - 1].span + 1;
              } else {
                raw.push({ span: 0, item: response[tier][session] });
              }
            }
          });
          this.categories[tier].options = raw;
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.processLoading = false;
      }
    },
  },
};
</script>
